import ModalMessage from "../ModalMessage/ModalMessage"
import Icon from "../Icon/Icon"
import "./ModalPurchaseAfterPreview.scss"
import { useNavigate } from 'react-router-dom';

const ModalPurchaseAfterPreview = ({ onClose, onPurchase, price, currency }) => {
    const navigate = useNavigate();
    return (<ModalMessage
        children={<div className="d-flex f-column aic jcc w-full">
            <Icon alias="purchase_after_preview" width={200} height={200} color="#FF3232" />
            <p className="fs-sm2 fw-bold mb-40 mt-32 ta-center">
                Purchase this creation
                to continue playing</p>
            <button
                className="btn red-btn btn-full aic jcc fw-extra-bold mb-24"
                style={{ height: '64px' }}
                onClick={() => onPurchase()}
            >
                <span>
                    {"BUY NOW"}

                    {<p className="fs-tiny fw-medium fg-white mt-2 ta-center tt-capitalize mb-0">
                        Secured by Stripe
                    </p>}
                </span>
                <span className="purchase-price">{price} {currency}</span>

            </button>
            <p className="fs-xxs fg-dark fw-bold mb-16 mt-0 c-pointer td-underline" onClick={onClose}
            >CANCEL</p>
        </div>}

    />
    )
}
export default ModalPurchaseAfterPreview